import React, { useState } from "react";
import "./Contact_us.css";
import { Button, Form } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Common_Back_Btn from "../../common_components/common_back_btn/Common_Back_Btn";
import {
  faArrowRight,
  faBriefcase,
  faEnvelope,
  faPhone,
  faShoppingBag,
} from "@fortawesome/free-solid-svg-icons";
import Purple_Btn from "../../common_components/common_btn/purple_btn/Purple_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { Controller, useForm } from "react-hook-form";
import { ContactUsForm } from "../../../utils/luxuryapis/form/form";
import { RegxExpression } from "../../../utils/common";
import Success_modal from "../../common_components/success_modal/Success_modal";

function Contact_us() {
  const navigate = useNavigate();
 

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();
  const [modalShow, setModalShow] = React.useState(false);
  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("subject", data?.subject);
    formData.append("message", data?.message);
    formData.append("agree_status", data?.agree_status);
    formData.append("name", data?.name);
    formData.append("email", data?.email);
    formData.append("contact_no", data?.contact_no);

    const res = await ContactUsForm(formData);
    if (res?.success) {
      reset();
      setModalShow(true);
      setTimeout(() => {
        setModalShow(false);
      }, 3000);
    } else {
    }
  };
  return (
    <>
      <section className="Contact_us">
        <div className="custom_container">
          <Common_Back_Btn backText={"Back"} />

          <div className="content_box_holder mt-3">
            <div className="heading_strip_holder">
              <h1>CONTACT US</h1>
              <hr />
            </div>

            <div className="heading_text_holder">
              <div className="row">
                <div className="col-md-4">
                  <p>
                    <FontAwesomeIcon icon={faPhone} className="contact_icon" />{" "}
                    Call: +91 731 6711 800/ +91 93029 11233
                  </p>
                </div>

                <div className="col-md-4">
                  <p>
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      className="contact_icon"
                    />{" "}
                    sales@mittalcraftworks.com
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <p>
                    <FontAwesomeIcon
                      icon={faBriefcase}
                      className="contact_icon"
                    />{" "}
                    Monday To Saturday 10:00 am - 06:00 pm IST,
                  </p>
                </div>
              </div>
              <div className="mt-3">
                <h3>
                  Have questions? Check out our{" "}
                  <span onClick={() => navigate("/luxury/faq")}> FAQs </span>{" "}
                  for quick answers.{" "}
                </h3>
                <h3>Do you still need help? Feel free to contact us!</h3>
              </div>
            </div>
            <div className="form_holder">
              <Form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-md-6">
                    {/* Name */}
                    <Form.Group className="mb-3">
                      <Form.Label>Enter Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter Name"
                        {...register("name", {
                          required: "Name is required",
                        })}
                        className={classNames("", {
                          "is-invalid": errors?.name,
                          "is-valid": getValues("name"),
                        })}
                        onKeyDown={(event) => {
                          if (!RegxExpression.name.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      {errors?.name && (
                        <sup className="text-danger mt-3">
                          {errors?.name?.message}
                        </sup>
                      )}
                    </Form.Group>
                  </div>
                  {/* <div className="col-md-6">
                   
                    <Form.Group className="mb-3">
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control type="text" placeholder="Enter Last Name" />
                    </Form.Group>
                  </div> */}
                  <div className="col-md-12">
                    {/* Email */}
                    <Form.Group className="mb-3">
                      <Form.Label>Enter Email Address*</Form.Label>
                      <Form.Control
                        type="text"
                        name="email"
                        placeholder="Enter Email Address"
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            value: RegxExpression.email,
                            message: "Invalid email address",
                          },
                        })}
                        className={classNames("", {
                          "is-invalid": errors?.email,
                          "is-valid": getValues("email"),
                        })}
                      />
                      {errors?.email && (
                        <sup className="text-danger mt-3">
                          {errors?.email?.message}
                        </sup>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-md-12">
                    {/* Phone */}
                    <Form.Group className="mb-3">
                      <Form.Label>Contact*</Form.Label>
                      <Controller
                        name="contact_no"
                        control={control}
                        rules={{
                          required: "Field is required",
                          pattern: {
                            value: /^\+?\d{1,4}[-\s]?\d{10}$/,
                            message:
                              "Invalid number format. Please enter a valid number with an optional country code",
                          },
                        }}
                        render={({ field }) => (
                          <PhoneInput
                            country={"in"}
                            {...field}
                            className={classNames("", {
                              "is-invalid": errors?.contact_no,
                              "is-valid": getValues("contact_no"),
                            })}
                            onChange={(value) => field.onChange(value)}
                            type="text"
                            placeholder="Enter Mobile Number"
                            onKeyDown={(event) => {
                              if (!RegxExpression.phone.test(event.key)) {
                                if (event.key !== "Backspace") {
                                  event.preventDefault();
                                }
                              }
                            }}
                            maxLength={10}
                          />
                        )}
                      />
                      {errors?.contact_no && (
                        <sup className="text-danger mt-3">
                          {errors?.contact_no?.message}
                        </sup>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-md-12">
                    {/* Select Subject* */}
                    <Form.Group className="mb-3">
                      <Form.Label> Select Subject*</Form.Label>
                      <Form.Control
                        type="text"
                        name="subject"
                        placeholder="Enter Subject"
                        {...register("subject", {
                          validate: (value) =>
                            value || getValues("message")
                              ? true
                              : "Subject or Message is required",
                          // required: "subject required",
                        })}
                        className={classNames("", {
                          "is-invalid": errors?.subject,
                          "is-valid": getValues("subject"),
                        })}
                      />
                      {errors?.subject && (
                        <sup className="text-danger">
                          {errors?.subject?.message}
                        </sup>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-md-12">
                    {/* Message */}
                    <Form.Group className="mb-4">
                      <Form.Label>Your Message</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        name="message"
                        placeholder="Enter Message"
                        {...register("message", {
                          validate: (value) =>
                            value || getValues("subject")
                              ? true
                              : "Message or Subject is required",
                        })}
                        className={classNames("", {
                          "is-invalid": errors?.message,
                          "is-valid": getValues("message"),
                        })}
                      />

                      {errors?.message && (
                        <sup className="text-danger">
                          {errors?.message?.message}
                        </sup>
                      )}
                    </Form.Group>
                  </div>
                </div>

                <div className="policy_text_holder">
                  <div className="row">
                    <div className="col-md-8">
                      {/* Button */}
                      <div className="policy_text">
                        <p>
                          By sending your message, you agree to accept the{" "}
                          <span onClick={() => navigate("/luxury/terms-conditions")}>General Terms and Conditions of Use </span>
                        </p>
                        <p>
                          Your data will be processed in compliance with {" "}
                          <span onClick={() => navigate("/luxury/privacy-policy")}>Mittal Craftworks’ Privacy Policy.</span>
                        </p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="btn_holder">
                        <Purple_Btn
                          btnText={"Send"}
                          rightIcon={faArrowRight}
                          type="submit"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
        <Success_modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          successText={"SEND REQUEST SUCCESSFULLY!"}
        />
      </section>
    </>
  );
}

export default Contact_us;
